import { RiskProductKeyMetric } from './creditRiskLevels.dto';

export enum RiskDistributionGroupBy {
  SECTOR = 'sector',
  RATING = 'acr_level_4',
}

export enum RiskDistributionMetric {
  CRL = 'crl',
  CQS = 'cqs',
  CRT_6M = 'crt-6m',
  CQD = 'cqd',
}

export interface RiskDistributionDto {
  key: string;
  metric: RiskProductKeyMetric;
  count: number;
  companyIds: number[];
}

export interface RiskDistributionsDto {
  data: RiskDistributionDto[];
}
